var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3414 3.07072C12.4969 2.64843 11.5027 2.64843 10.6582 3.07072L4.7998 5.9999V14.0279C4.7998 16.1999 7.36221 18.6711 11.9998 21.5999C16.6374 18.6711 19.1998 16.7999 19.1998 14.0279C19.1998 11.2559 19.1998 5.9999 19.1998 5.9999L13.3414 3.07072Z",
    stroke: "#0D0C0C",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.d21f35d07674bab7258be19b4849a22f.svg";
export { ForwardRef as ReactComponent };